module.exports = __webpack_public_path__ + "img/HUAZHU.e37b4961.png";